import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  AfterViewChecked,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { AutocompleteInterfaces } from '../../interfaces/input';
import {
  numberRegex,
  textRegex,
  alphanumericRegex,
  passwordRegex,
} from '../../../../shared/utils/regex';
import {
  InputInterface,
  ErrorMessagesInterface,
} from '@modules/input/interfaces/input';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent
  implements InputInterface, OnDestroy, AfterViewChecked, OnChanges
{
  public clickIcon = false;
  public iconMain: string = '';
  public tmpFeatherIcon: string = '';
  public flatControl = false;
  public maxLength!: number;
  public minLength!: number;
  public inputype:
    | 'text'
    | 'number'
    | 'email'
    | 'password'
    | 'tel'
    | 'alphanumeric'
    | 'search'
    | 'code'
    | 'textSymbolsNumbers' = 'text';

  @Input() control!: FormControl;
  @Input() blockPaste: boolean = false;
  @Input() blockCopy: boolean = false;
  @Input() blockCut: boolean = false;
  @Input() idInput: string | null = null;
  @Input() textCaption: string | null = null;
  @Input() set featherIcon(icon: string) {
    this.iconMain = icon;
    this.tmpFeatherIcon = icon;
  }
  @Input() featherIconChange: string = '';
  @Input() addChangeIcon: boolean = false;
  @Input() placeholder: string = '';
  @Input() label: string | null = null;
  @Input() set inputType(value: any) {
    this.inputype = value;
  }
  @Input() value: string = '';
  @Input() disabled: boolean = false;
  @Input() errorMessages: ErrorMessagesInterface = {};
  @Input() successMessage: string | null = null;
  @Input() autocomplete: Array<AutocompleteInterfaces> = [];
  @Input() set maxlength(num: number) {
    this.maxLength = num;
  }
  @Input() set minlength(num: number) {
    this.minLength = num;
  }
  @Input() pattern!: string;
  @Output() OnSetValue: EventEmitter<any> = new EventEmitter();
  @Output() OnClickIcon: EventEmitter<boolean> = new EventEmitter();

  private controlSubcription!: Subscription;

  public lestValueInput: string | number | undefined = undefined;
  public isValidPassword: boolean = false;
  public defaultErrors = {
    required: 'Este campo es obligatorio.',
    minlength: 'Mínimo X caracteres.',
    maxlength: 'Máximo X caracteres.',
    email: 'Correo electrónico inválido.',
    number: 'Escribe solo números.',
    codeError: 'Código de confirmación inválido.',
  };

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewChecked(): void {
    if (this.control && this.flatControl === false) {
      this.detectChanges();
      this.flatControl = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.control && changes['disabled']) {
      changes['disabled'].currentValue
        ? this.control.disable()
        : this.control.enable();
    }
    this.detectChanges();
  }

  detectChanges() {
    if (this.inputype === 'password') {
      this.iconMain = 'eye';
      this.isValidPassword = true;
    }

    this.errorMessages = {
      ...this.defaultErrors,
      minlength: this.getMinLength(),
      maxlength: this.getMaxLength(),
      ...this.errorMessages,
    };

    if (
      this.control &&
      this.inputype !== 'code' &&
      this.inputype !== 'textSymbolsNumbers'
    ) {
      this.controlSubcription = this.control.valueChanges.subscribe((data) => {
        if (this.lestValueInput !== data && data) {
          if (!this.pattern) {
            data = this.validateTypeInput('number', data, numberRegex);

            data = this.validateTypeInput(
              'text',
              data,
              this.isValidPassword ? passwordRegex : textRegex
            );

            data = this.validateTypeInput(
              'alphanumeric',
              data,
              alphanumericRegex
            );
          }

          if (this.pattern) {
            data = this.validateTypeInput('pattern', data, this.pattern);
          }

          data = this.inputype === 'email' ? data.toLowerCase() : data;
          if (this.inputType === 'email' && data.includes('+')) {
            data = this.lestValueInput;
          }
          this.lestValueInput = data;
          this.control.setValue(data.slice(0, this.maxLength));
        }

        this.changeDetectorRef.detectChanges();
      });
    }

    this.changeDetectorRef.detectChanges();
  }

  keyPressNumbers(e: any) {
    if (this.inputype === 'number') {
      const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
      const charStr = String.fromCharCode(charCode);
      const regex = /^\d+$/;
      if(!regex.exec(charStr)){
        e.preventDefault();
      }
    }
  }

  validateTypeInput(type: string, data: string, regex: any) {
    if (type === 'pattern') {
      return !regex?.test(data) ? data : this.lestValueInput;
    } else {
      return this.inputype === type && !regex?.test(data)
        ? this.lestValueInput
        : data;
    }
  }

  displayError(errors: {}) {
    return this.errorMessages[Object.keys(errors)[0]];
  }

  setValue(value: any) {
    this.OnSetValue.emit(value);
  }

  getMinLength() {
    return `Mínimo ${this.minLength} caracteres.`;
  }

  getMaxLength() {
    return `Máximo ${this.maxLength} caracteres.`;
  }

  onClickIcon() {
    if (this.isValidPassword) {
      this.inputype = this.iconMain === 'eye' ? 'text' : 'password';
      this.iconMain = this.iconMain === 'eye' ? 'eye-off' : 'eye';
    }

    if (this.addChangeIcon) {
      this.clickIcon = !this.clickIcon;
      this.OnClickIcon.emit(this.clickIcon);
      this.iconMain = this.clickIcon
        ? this.featherIconChange
        : this.tmpFeatherIcon;
    }
  }

  numberOnly(event, type): boolean {
    if (type === 'tel') {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
    }
    return true;
  }

  handleInputType() {
    return this.inputype === 'alphanumeric' ||
      this.inputype === 'textSymbolsNumbers'
      ? 'text'
      : this.inputype;
  }

  onCodeChanged(code: string) {
    this.control.setValue(code);
    this.control.markAsTouched();
  }

  onCodeCompleted(code: string) {
    this.control.setValue(code);
    this.control.markAsTouched();
  }

  ngOnDestroy(): void {
    this.controlSubcription && this.controlSubcription.unsubscribe();
  }
}
